import { ENCODED_JSON_CONTENT_TYPE } from '@shared/transport/encoded-json';

export { ENCODED_JSON_CONTENT_TYPE };

/*
 * btoa takes a "binary string" (one char per byte). Building it with
 * String.fromCharCode over the whole buffer overflows the call stack on large
 * chat payloads, so the bytes are fed through in chunks.
 */
const CHUNK = 0x8000;

/**
 * Serialize a value as a base64 JSON body. Code-bearing requests (chat saves,
 * chat turns, file writes) use this so Render's edge firewall has nothing to
 * mistake for an attack — see ENCODED_JSON_CONTENT_TYPE. The server decodes it
 * back to the same JSON.
 */
export function encodeJsonBody(value: unknown): string {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let binary = '';

  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }

  return btoa(binary);
}

/** A body axios would otherwise send as JSON: a plain object or an array. */
export function isJsonBody(data: unknown): data is object {
  if (data === null || typeof data !== 'object') {
    return false;
  }

  if (Array.isArray(data)) {
    return true;
  }

  const proto = Object.getPrototypeOf(data);

  return proto === Object.prototype || proto === null;
}

/** True when a fetch/axios error body is Render's firewall "Blocked" page. */
export function isFirewallBlockPage(text: string | undefined | null): boolean {
  return Boolean(text && /<title>\s*Blocked\s*<\/title>/i.test(text));
}
